// The payload is the deleted provider's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type AiProviderDeletedPayload = {
	providerId: number;
};

export type AiProviderDeletedAction = {
	type: 'AI_PROVIDER_DELETED';
	payload: AiProviderDeletedPayload;
	accountId: number;
};

export default (payload: AiProviderDeletedPayload, accountId: number): AiProviderDeletedAction => ({
	type: 'AI_PROVIDER_DELETED',
	payload,
	accountId,
});
